export const COMMENT_LIST_LIMIT = 50;

export const REGEX_LINK = /(https?:\/\/[\w!?/+\-_~=;.,*&@#$%()'[\]]+)/;
export const REGEX_COMMUNITY_REPLY = />>(\d)+(\s)?/;

export const TAG_ID_RECENT = 'recent';
export const TAG_ID_FOLLOWED = 'followed';
export const INITIAL_TAG_LIST = [
  {id: TAG_ID_RECENT, name: '新着'},
  {id: TAG_ID_FOLLOWED, name: 'フォロー中'},
];

export const DEFAULT_NICKNAME = '匿名外資さん';
